<template>
  <section
    class="feedback-section"
    :style="paddingCalculator"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <div>
      <div class="container">
        <h2 class="feedback-ttl font-24">
          {{ _.get(contentData, `conf.header.title`) }}
        </h2>
        <div class="feedback-desc text mt-34">
          {{ _.get(contentData, `conf.header.teaser`) }}
        </div>
        <div class="form-outer mt-34">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="form-container flex-box between"
          >
            <div class="form-col form-col-left">
              <el-form-item prop="name" class="input-box without-select">
                <el-input
                  v-model="ruleForm.name"
                  :class="{ 'label-class': ruleForm.name }"
                  >>
                  <template slot="append">{{ $fn.tr("Your Name") }} </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="phone" class="input-box without-select">
                <el-input
                  type="number"
                  oninput="javascript: if (this.value.length > 15) this.value = this.value.slice(0, 15);"
                  maxlength="15"
                  v-model="ruleForm.phone"
                  :class="{ 'label-class': ruleForm.phone }"
                  >>
                  <template slot="append">{{ $fn.tr("Your phone") }} </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="area" class="input-box">
                <el-select
                  v-model="ruleForm.area"
                  :placeholder="$fn.tr('Area of Interest')"
                  popper-class="form-dropdown-list"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in feedbackArea"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="email" class="input-box without-select">
                <el-input
                  v-model="ruleForm.email"
                  :class="{ 'label-class': ruleForm.email }"
                >
                  <template slot="append">
                    {{ $fn.tr("Your Email") }}
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="residency" class="input-box without-select">
                <el-input
                  v-model="ruleForm.residency"
                  :class="{ 'label-class': ruleForm.residency }"
                  >>
                  <template slot="append"
                    >{{ $fn.tr("Residency (City, Country)") }}
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item
                class="radio-box"
                :label="$fn.tr('Preferred medium of communication:')"
                prop="communication"
              >
                <el-radio-group v-model="ruleForm.communication">
                  <el-radio :label="$fn.tr('E-Mail')"></el-radio>
                  <el-radio :label="$fn.tr('Call')"></el-radio>
                  <el-radio :label="$fn.tr('Meeting')"></el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="form-col form-col-right">
              <el-form-item prop="desc" @click.native="clicktext = true">
                <el-input
                  type="textarea"
                  v-model="ruleForm.desc"
                  :class="[
                    { 'label-class': ruleForm.desc },
                    { 'pointer-none': !clicktext }
                  ]"
                >
                  <template slot="append"> {{ $fn.tr("Message") }} </template>
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  @click="submitForm('ruleForm')"
                  class="submit-btn flex-box al-center justify-center"
                >
                  <ArrowIcon />
                  <span class="tbc-bold uppercase">
                    {{ $fn.tr("Submit") }}</span
                  >
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <transition name="toggleContent" mode="out-in">
      <portal to="destination">
        <div class="success-modal-container" v-if="success">
          <div class="success-modal">
            <div class="success-modal-text">
              {{ $fn.tr("Your massage sent sucsusfully") }}
            </div>
            <svg
              @click="resetForm"
              xmlns="http://www.w3.org/2000/svg"
              width="24.042"
              height="24.042"
              viewBox="0 0 24.042 24.042"
            >
              <g
                id="Group_6332"
                data-name="Group 6332"
                transform="translate(-2.979 2.021)"
              >
                <rect
                  id="Rectangle_543"
                  data-name="Rectangle 543"
                  width="30"
                  height="4"
                  rx="2"
                  transform="translate(5.808 -2.021) rotate(45)"
                  fill="#fff"
                />
                <rect
                  id="Rectangle_2206"
                  data-name="Rectangle 2206"
                  width="30"
                  height="4"
                  rx="2"
                  transform="translate(2.979 19.192) rotate(-45)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
        </div>
      </portal>
    </transition>
  </section>
</template>

<script>
import ArrowIcon from "../ArrowIcon";
import fn from "@/helpers/func";
import paddingCalculator from "@/mixins/paddingMixin";

export default {
  props: ["contentData", "evenOdd"],
  mixins: [paddingCalculator],
  components: {
    ArrowIcon
  },
  data() {
    const _this = this;

    return {
      ruleForm: {
        name: "",
        phone: "",
        area: "",
        email: "",
        residency: "",
        communication: "",
        desc: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: _this.$fn.tr("Please input your Name"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: _this.$fn.tr("Please input your phone number"),
            trigger: "blur"
          }
          // {
          //   type: "number",
          //   message: _this.$fn.tr("Please input number"),
          //   trigger: "blur"
          // }
        ],
        area: [
          {
            required: true,
            message: _this.$fn.tr("Please select your area"),
            trigger: "change"
          }
        ],
        email: [
          {
            required: true,
            message: _this.$fn.tr("Please input your email address"),
            trigger: "blur"
          },
          {
            type: "email",
            message: _this.$fn.tr("Please input correct email address"),
            trigger: ["blur", "change"]
          }
        ],
        residency: [
          {
            required: true,
            message: _this.$fn.tr("Please input your residency"),
            trigger: "blur"
          }
        ],
        communication: [
          {
            required: true,
            message: _this.$fn.tr("Please select communication form"),
            trigger: "change"
          }
        ],
        desc: [
          {
            required: true,
            message: _this.$fn.tr("Please write your Feedback"),
            trigger: "blur"
          }
        ]
      },
      clicktext: false,
      success: false
    };
  },
  computed: {
    feedbackArea() {
      return _.get(this.$store.state.main.indx, "terms.contactForm").filter(
        itm => itm.field_name === "feedback_area"
      );
    }
    // formType() {
    //   return this.ruleForm.type;
    // }
  },
  watch: {
    // formType(val) {
    //   if (val) {
    //     this.ruleForm.recipient = "";
    //   }
    // }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          fn.postData("main/contactform", this.ruleForm).then(res => {
            if (res.data.success) {
              this.success = true;
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs["ruleForm"].resetFields();
      this.success = false;
    }
  },
  mounted() {
    let selectDropdownList = document.querySelectorAll(".form-dropdown-list");
    let textArea = document.querySelector(
      ".form-container .el-textarea__inner"
    );

    setTimeout(function() {
      selectDropdownList.forEach(function(item) {
        item.addEventListener("scroll", function(e) {
          e.stopPropagation();
        });
        item.addEventListener("mousewheel", function(e) {
          e.stopPropagation();
        });
      });
    }, 500);

    setTimeout(function() {
      textArea.addEventListener("scroll", function(e) {
        e.stopPropagation();
      });
      textArea.addEventListener("mousewheel", function(e) {
        e.stopPropagation();
      });
    }, 500);
  }
};
</script>

<style scoped>
.success-modal-container {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-modal {
  background: #00a3e0;
  border-radius: 4px;
  min-width: 385px;
  padding: 0 25px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.success-modal svg {
  cursor: pointer;
  margin-left: 20px;
}
.pointer-none {
  pointer-events: none;
}
.success-modal-text {
  font-size: 18px;
}
.form-col {
  width: calc(50% - 15px);
}

.feedback-desc {
  max-width: 450px;
  opacity: 0.8;
}
.form-warning {
  margin-top: 31px;
  margin-bottom: 38px;
  line-height: 18px;
}
.form-warning a {
  color: var(--tbc-blue);
  /* text-decoration: underline; */
  transition: 0.4s;
  text-decoration-color: var(--tbc-blue);
}
.form-warning a:hover {
  text-decoration-color: transparent;
}
.form-container .el-select {
  width: 100%;
}
.submit-btn {
  height: 60px;
  width: 100%;
  background: linear-gradient(to right, #015bc1 0, #26dffe 100%);
}
.submit-btn span {
  color: #ffffff;
  margin-left: 14px;
  display: inline-block;
  transition: 0.6s cubic-bezier(0.15, -0.01, 0, 0.99);
  transition-delay: 0.2s;
}
.submit-btn svg {
  transition: 0.6s cubic-bezier(0.15, -0.01, 0, 0.99);
  transition-delay: 0s;
}
.submit-btn:hover svg {
  transform: translateX(10px);
  transition-delay: 0.2s !important;
  transition: 0.6s cubic-bezier(0.15, -0.01, 0, 0.99);
}
.submit-btn:hover span {
  transform: translateX(10px);
  transition-delay: 0s;
  transition: 0.6s cubic-bezier(0.15, -0.01, 0, 0.99);
}
.input-box:not(:last-child) {
  margin-bottom: 30px;
  transition: 0.3s;
}
.input-box.is-error {
  margin-bottom: 25px !important;
}
.radio-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.form-container >>> .el-form-item__label {
  color: #dadada;
  font-size: 12px;
}
.form-container >>> .el-form-item__label:before {
  display: none;
}
.form-container >>> .el-radio__input.is-checked + .el-radio__label {
  color: #dadada;
}
.form-container >>> .el-radio__input .el-radio__inner {
  border: 1px solid #dadada;
  border-width: 1px;
  background: #1d2934;
  width: 18px;
  height: 18px;
  transition: transform 0.15s ease-in;
}
.form-container >>> .el-radio__inner::after {
  width: 12px;
  height: 12px;
  width: 12px;
  height: 12px;
  background: #00aeef;
}

.form-container >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
}
.form-container >>> .el-select-dropdown {
  background: var(--oppositeColor);
  border-color: transparent !important;
}
@media (max-width: 1023px) {
  .feedback-section.pb-89 {
    padding-bottom: 55px;
  }
}
@media (max-width: 767px) {
  .form-container {
    flex-direction: column;
  }
  .form-col {
    width: 100%;
  }
  .input-box:not(:last-child) {
    margin-bottom: 12px;
  }
  .input-box:last-child {
    margin-bottom: 16px;
  }
  .feedback-ttl.font-24 {
    font-size: 16px;
  }
  .feedback-desc.mt-34,
  .form-outer.mt-34 {
    margin-top: 21px;
  }
}
</style>

<style>
.form-container .el-input__inner {
  width: 100%;
  height: 60px;
  padding-left: 24px;
  border-radius: 6px;
  border-color: #f4f6f8;
  background: var(--oppositeColor) !important;
  border: 1px solid transparent !important;
}
.form-container .el-textarea__inner {
  width: 100%;
  height: 273px;
  max-height: 273px;
  border-radius: 6px;
  padding-top: 22px;
  padding-left: 24px;
  border-color: transparent;
  background: var(--oppositeColor) !important;
  resize: none;
}
.form-container .el-textarea__inner::-webkit-scrollbar {
  width: 3px;
  background: #00aeef;
}

.form-container .el-input--suffix .el-input__inner {
  padding-right: 55px;
}
.form-container .el-select .el-input.is-focus .el-input__inner,
.form-container .el-select .el-input__inner:focus {
  border-color: #00aeef;
}

.form-container .el-input__suffix {
  right: 17px;
}
.form-container .el-select .el-input .el-select__caret {
  color: #dadada;
  font-size: 15px;
  font-weight: 700;
}
.form-dropdown-list {
  left: 0 !important;
  max-width: 20%;
}
.form-dropdown-list .el-select-dropdown__item {
  display: flex;
  padding: 10px 20px;
  white-space: normal;
  line-height: unset;
  height: auto;
}
.form-dropdown-list .el-select-dropdown__item span {
  color: #737373;
  font-size: 16px;
  line-height: 20px;
}
.form-dropdown-list.el-popper .popper__arrow,
.form-dropdown-list.el-popper .popper__arrow::after {
  display: none;
}
.form-dropdown-list .el-select-dropdown__item span {
  transition: 0.6s;
}
.form-dropdown-list .el-select-dropdown__item:hover span {
  color: #00aeef;
}
.form-dropdown-list .el-select-dropdown__item.selected span {
  font-weight: normal;
  color: #00aeef;
}
.form-dropdown-list .el-select-dropdown__item.hover,
.form-dropdown-list .el-select-dropdown__item:hover {
  background: none;
}
.form-container .el-button {
  border-radius: 6px;
  outline: none;
  border: 1px solid #364756;
  background: transparent;
}
.form-container .el-form-item {
  margin-bottom: 30px;
  position: relative;
}
.submit-btn svg path {
  fill: #fff;
}
.el-input,
.el-input__prefix,
.el-input__suffix {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
